angular.module('rjmNg.directives').directive "metricList", [
  () ->
    restrict: "E"
    templateUrl: "directive.metricList.html"
    replace: true
    controllerAs: 'view'
    scope: {
      metricGroups : '<'
      updateMetricDetails: '&'
      removeMetrics: '&'
      showDepResolver: '&'
    }
    bindToController: true
    require: "^?rjmUi"
    controller: [
      "$routeParams"
      "logger"
      "notification"
      "Metrics"
      "app"
      "StructureCache"
      "FilterSets"
      "metricEnums"
      "errorConstants"
      "dependencyEnums"
      "$url"
      "$q"
      "$rootScope"
      (
        $routeParams
        logger
        notification
        Metrics
        app
        StructureCache
        FilterSets
        metricEnums
        errorConstants
        dependencyEnums
        $url
        $q
        $rootScope
      ) ->

        view = @
        view.supportEmail = app.getSupportEmail()
        view.baseUrl = $url("")
        view.notificationTemplate = 'template.notification.supportLink.html'
        view.loading = true
        view.isAdmin = app.isAdminUser()
        view.isSupportUser = app.isSupportUserSession()
        _clientId = $routeParams.clientId

        view.filterSets = []
        view.metrics = []
        view.tables = []
        view.columns = []
        view.tableSearchTerm = ""

        view.dimensionEditorActions = metricEnums.DIMENSION_EDITOR_ACTIONS
        view.showDimensionEditor = false
        view.dimensionEditorAction = metricEnums.DIMENSION_EDITOR_ACTIONS.ADD

        view.dependencyPromises = {}
        view.showDependencyResolver = false
        view.depReadOnly = false
        view.depResourceType = dependencyEnums.RESOURCE_TYPES.METRIC
        view.dependencyTypes = dependencyEnums.RESOURCE_DEPENDENCIES
        view.depResourceNames = {}
        view.depConfirmMsg = "Delete metric and reports?"

        notificationTimeout = 15

        _confirmDeleteCallback = (choices) ->
          deletePromises = []
          metricIds = []
          for id,value of choices when value.selected
            view.loading = true
            deletePromises.push Metrics.delete(_clientId, id)
            metricIds.push(parseInt(id,10))
          $q.all(deletePromises).then(
            (response) ->
              view.removeMetrics({metricIds})
            , (error) ->
              view.loading = false
              notification.error("Server Error",
                errorConstants.SERVER_ERROR_MESSAGE,
                "metrics",
                null,
                notificationTimeout
              )
          )

        view.expandMetric = (metric) ->
          metric.expanded = !metric.expanded
          if(metric.expanded)
            metric.isLoading = true
            view.updateMetricDetails({metric: metric}).finally(() -> metric.isLoading = false)

        view.deleteMetric = (metric) ->
          if(view.isAdmin)
            dr = {}
            dr.depResourceType = dependencyEnums.RESOURCE_TYPES.METRIC
            dr.depConfirmMsg = "Delete metric and reports?"
            dr.dependencyPromises = {}
            dr.depResourceNames = {}
            metricName = metric.name
            dr.dependencyPromises[metric.id] = Metrics.dependents(
              _clientId,
              metric.id, 
              true
            )
            dr.depResourceNames[metric.id] =
                name: metricName
            dr.confirmDelete = _confirmDeleteCallback
            view.showDepResolver({dep: dr})

        view.expand = (metric) ->
          metric.expand = !metric.expand
          $rootScope.$broadcast('expandMetricDetails', metric.id)

        logger.log('Metrics Page Usage', 'Open', 1, 'list')

        return view
    ]
]
